<template>
  <section
    v-if="!textBox.isIndBenefit"
    class="text-box no-flicker"
    :class="{ active: active }"
    :style="{
      bottom: textBox.position.bottom + '%',
      left: textBox.position.left + '%'
    }"
  >
    <div class="text-box__exit-area">
      <div class="text-box__exit-area__text-box-button" @click="endAnimation">
        <p class="font text-box__exit-area__text-box-button__exit">EXIT</p>
        <img class="text-box__exit-area__text-box-button__icon" :src="exitIcon" alt />
      </div>
    </div>
    <div class="text-box__text-area">
      <div class="text-box__text-area__wrapper">
        <div v-if="textBox.icon" class="text-box__text-area__wrapper__icon">
          <img :src="textBox.icon" alt />
        </div>
        <div
          class="font text-box__text-area__wrapper__text"
          :class="{ 'full-width': !textBox.icon }"
        >
          <p id="textBoxText" v-html="textBox.text"></p>
        </div>
      </div>
    </div>
    <div class="text-box__progress-bar">
      <div class="text-box__progress-bar__animation-progress no-flicker">
        <div
          class="text-box__progress-bar__animation-progress__progress no-flicker"
          :style="{
            transform:
              'scaleX(' + Math.min(voiceOverTime / totalVoiceOverTime, 1) + ')'
          }"
        ></div>
      </div>
    </div>
    <div class="text-box__next-area">
      <div v-if="lastTextBox" class="text-box__next-area__text-box-button" @click="finishAnimation">
        <p class="font text-box__next-area__text-box-button__next">FINISHED</p>
        <img class="text-box__next-area__text-box-button__icon" :src="nextArrowIcon" alt />
      </div>
      <div v-else class="text-box__next-area__text-box-button no-flicker" @click="onNext">
        <p class="font text-box__next-area__text-box-button__next">NEXT</p>
        <img class="text-box__next-area__text-box-button__icon" :src="nextArrowIcon" alt />
      </div>
    </div>
    <div
      class="text-box__pointer-area"
      :class="{
        'arrow-left':
          textBox.arrowPosition !== 'center' &&
          textBox.arrowPosition !== 'right',
        'arrow-center': textBox.arrowPosition === 'center',
        'arrow-right': textBox.arrowPosition === 'right'
      }"
    >
      <div
        class="arrow-down"
        :class="{
          'arrow-left-margin':
            textBox.arrowPosition !== 'center' &&
            textBox.arrowPosition !== 'right',
          'arrow-right-margin': textBox.arrowPosition === 'right'
        }"
      ></div>
    </div>
  </section>
  <industry-benefit-text-box
    v-else
    :onClose="onClose"
    :onFinish="onFinish"
    :textBox="textBox"
    :next="next"
  />
</template>

<script>
import IndustryBenefitTextBox from "./IndustryBenefitTextBox.vue";
import nextArrowIcon from "@/assets/text-box-accents/next-arrow.svg";
import exitIcon from "@/assets/text-box-accents/exit-icon.svg";

import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "text-box",
  components: {
    IndustryBenefitTextBox
  },
  props: [
    "textBox",
    "onClose",
    "onFinish",
    "next",
    "updated",
    "continueAnimation",
    "lastTextBox",
    "previousProgress",
    "animationProgress",
    "active"
  ],
  data() {
    return {
      nextArrowIcon,
      exitIcon,
      i: 0,
      typeTimeOuts: [],
      progressMotion: this.previousProgress
    };
  },
  computed: {
    ...mapState({
      voiceOverTime: state => state.moduleMacroAnimations.voiceOverTime,
      totalVoiceOverTime: state =>
        state.moduleMacroAnimations.totalVoiceOverTime,
      totalWaitTime: state => state.moduleMacroAnimations.totalWaitTime,
      waitProgress: state => state.moduleMacroAnimations.waitProgress,
      voiceOver: state => state.audio.voiceOver,
      currentAnimationName: state => state.analytics.currentAnimationName,
      currentVoiceOverName: state => state.analytics.currentVoiceOverName
    })
  },
  methods: {
    ...mapMutations([
      "updateWaitProgress",
      "updateTotalWaitTime",
      "setVoiceOver",
      "updateStopTimeIdx",
      "updateShowAmbientAnimations"
    ]),
    endAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Canceled Selection",
        eventLabel: `CANCELED_STORY_TEXTBOX: ${this.currentAnimationName} was canceled at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      this.updateShowAmbientAnimations(true);
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.updateWaitProgress(0);
      this.onClose();

      this.updateStopTimeIdx(-1);
    },
    finishAnimation() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Skipped Selection",
        eventLabel: `SKIPPED_STORY_TEXTBOX: ${this.currentAnimationName} was skipped at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.updateWaitProgress(0);
      this.onFinish();

      this.updateStopTimeIdx(-1);
    },
    onNext() {
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Skipped Selection",
        eventLabel: `SKIPPED_STORY_TEXTBOX: ${this.currentAnimationName} was skipped at ${this.currentVoiceOverName} `,
        eventValue: 1
      });
      if (this.voiceOver) {
        this.voiceOver.pause();
        this.setVoiceOver(undefined);
      }
      this.next();
    },
    clearDelayTimeout() {
      for (let timeout of this.typeTimeOuts) {
        clearTimeout(timeout);
      }
    }
  },
  destroyed() {
    this.$destroy();
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";

.text-box {
  opacity: 1;
  position: absolute;
  width: 10.5vw;
  height: 4.1vw;
  transform: translateY(0%);
  &__exit-area {
    position: relative;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 20%;
    &__text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__exit {
        color: $color-white;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__text-area {
    position: relative;
    width: 100%;
    height: 46%;
    background-color: $color-white;
    &__wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 2%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      &__icon {
        width: 16%;
        height: 100%;
        margin-top: 2%;
        margin-left: 1%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &__text {
        padding: 0.3% 0;
        width: 81%;
        height: 100%;
        line-height: 0.4vw;
        font-size: 0.3vw;
        margin-left: 2%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
      }
    }
  }
  &__progress-bar {
    position: relative;
    width: 100%;
    height: 3%;
    background-color: $color-blue;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__animation-progress {
      width: 100%;
      height: 100%;
      &__progress {
        height: 100%;
        width: 100%;
        background-color: $color-lime;
        transform-origin: left;
        transform: scaleX(0);
      }
    }
  }
  &__next-area {
    height: 19%;
    display: flex;
    justify-content: flex-end;
    background-color: $color-black-transparent;
    &__text-box-button {
      cursor: pointer;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-end;
      align-content: center;
      align-items: center;
      &__next {
        color: $color-lime-bright;
        font-size: 0.4vw;
        margin-right: 0.3vw;
      }
      &__icon {
        height: 0.55vw;
        width: 0.55vw;
        margin-right: 0.3vw;
      }
    }
  }
  &__pointer-area {
    position: relative;
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
  }
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 0.5vw solid transparent;
  border-right: 0.5vw solid transparent;
  border-top: 0.4vw solid $color-black-transparent;
}
.arrow-left {
  justify-content: flex-start;
}
.arrow-left-margin {
  margin-left: 0.5vw;
}
.arrow-center {
  justify-content: center;
}
.arrow-right {
  justify-content: flex-end;
}

.arrow-right-margin {
  margin-right: 0.5vw;
}
.active {
  z-index: 200;
}

.full-width {
  width: 100%;
}
</style>
